import React, { useMemo } from 'react';
import classNames from 'classnames';
import StatTiles from '../StatTiles';
import { ResponsiveBar } from '@nivo/bar';
import { useTranslation } from 'react-i18next';
import { StagesStats } from '../../QAndAChart.component';
import useBarChart from 'hooks/useBarChart';

import './AnalitycsCardContent.styles.scss';
import './AnalitycsCardContent.styles.responsive.scss';

type AnalitycsCardContentProps = {
  className?: string;
  chartAndTileStats: StagesStats;
};

export const BY_SUBJECT_TEXT_MAP = {
  'Acquisitions and Disposals': 'ackAndDisp',
  Assets: 'assets',
  'Board and Management': 'boardAndM',
  Contracts: 'contracts',
  Corporate: 'corporate',
  'Customers and Marketing': 'customAndMar',
  Debt: 'debt',
  Equity: 'equity',
  Financials: 'financials',
  'Human Resources': 'hr',
  'Information Technology': 'it',
  'Intellectual Property': 'ip',
  Legal: 'legal',
  Tax: 'tax',
  'Transaction Documents': 'tranDoc',
  Other: 'other',
} as const;

const CHART_PADDING = 0.4;
const CHART_MARGIN = {
  top: 20,
  right: 0,
  bottom: 40,
  left: 40,
};
const AXIS = { tickSize: 0, tickPadding: 8 };
const COLOR = '#e7f1fc';

const AnalitycsCardContent: React.FC<AnalitycsCardContentProps> = (props) => {
  const { className, chartAndTileStats } = props;

  const { chartValues, tiles } = chartAndTileStats;

  const { t } = useTranslation();

  const chartData = useMemo(
    () =>
      chartValues.map(({ text, count }) => ({
        stage: t(
          BY_SUBJECT_TEXT_MAP?.[text as keyof typeof BY_SUBJECT_TEXT_MAP] ||
            text,
        ),
        value: count,
      })),
    [chartValues, t],
  );

  const { gridYValues } = useBarChart(chartData.map(({ value }) => value));

  const classes = classNames('analitycs-card-content', className);

  return (
    <div className={classes}>
      <div className="graph-cont-tiles">
        <StatTiles tiles={tiles} />
      </div>
      <div
        className="graph-cont"
        style={{ minHeight: `${((chartValues.length + 1) * 70) / 2}px` }}
      >
        <div
          style={{
            minWidth: `${(chartValues.length + 1) * 70}px`,
          }}
        >
          <ResponsiveBar
            indexBy="stage"
            data={chartData}
            enableLabel={false}
            isInteractive={false}
            padding={CHART_PADDING}
            margin={CHART_MARGIN}
            colors={COLOR}
            gridYValues={gridYValues}
            axisLeft={{
              ...AXIS,
              tickValues: gridYValues,
            }}
            axisBottom={AXIS}
          />
        </div>
      </div>
    </div>
  );
};

export default AnalitycsCardContent;
